module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop@2x_b9245e.jpg";